// extracted by mini-css-extract-plugin
export default {"description":"ForbesDisclaimerModal_description__f1UPY"};